import { render, staticRenderFns } from "./CardFramework.vue?vue&type=template&id=c33fc110&scoped=true"
import script from "./CardFramework.vue?vue&type=script&lang=ts"
export * from "./CardFramework.vue?vue&type=script&lang=ts"
import style0 from "./CardFramework.vue?vue&type=style&index=0&id=c33fc110&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33fc110",
  null
  
)

export default component.exports